// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1pdM6","footer":"ModalFilter_footer__21xaT"};